import React from "react";
import { ShimmerContent, ShimmerWrapper } from "./styles";

export default function Shimmer() {
  return (
    <ShimmerWrapper>
      <ShimmerContent />
    </ShimmerWrapper>
  );
}
